import { lowerCase } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

import { countryList, getCountryName } from '../CountryPicker/utils'
import Icon from '../Icon'

const Wrapper = styled.div``

function getIcon(shortcode: string): string {
  const value = lowerCase(shortcode)
  switch (value) {
    case 'en':
      return 'gb'
    default:
      return value
  }
}

type TCountry = {
  country: string
}

const Country = (props: TCountry): React.ReactElement => {
  const { country } = props

  return (
    <Wrapper>
      <Icon icon={`flag-icon flag-icon-${getIcon(country)}`} />{' '}
      {getCountryName(country)}
    </Wrapper>
  )
}

Country.propTypes = {
  country: PropTypes.oneOf(countryList),
}

export default Country
